import UUID from 'uuid'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { connect } from 'react-redux'
import ThemePanel from './ThemePanel'
import React, { Component } from 'react'
import DtoSource from '../../dto/DtoSource'
import AppStore from '../../../store/AppStore'
import DtoUser from '../../../home/dto/DtoUser'
import HomeAction from '../../../home/actions/HomeAction'
import AdministrationAction from '../../actions/AdministrationAction'

const $ = window.$

class FamilyComponent extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selected: 0
		}
	}

	componentWillMount() {
		this.setTitle()
		if (this.props.sources && !this.props.sources.length) {
			AppStore.dispatch(AdministrationAction.fetchSources())
		}
	}

	componentDidMount() {
		this.setTabs()
	}

	componentDidUpdate() {
		this.setTabs()
		this.setTitle()
	}

	setTabs = () => {
		$('ul.tabs').tabs()
	}

	setTitle() {
		const title = (
			<span>
                <a className='breadcrumb' onClick={ this.props.homeFunction }>{ i18n.sources }</a>
                <a className='breadcrumb'>{ this.props.theme.title }</a>
            </span>
		)
		AppStore.dispatch(HomeAction.setTitle(title))
	}

	handleChange = (event, newValue) => {
		this.setState({ selected: newValue })
	}

	render() {
		const tabs = []
		const themes = this.props.theme.themes.map(t => {
			const id = UUID.v4()
			const inDevelop = t.disable ? (<i className='material-icons'>visibility_off</i>) : null
			tabs.push(
				<li className='tab' key={ id }>
					<a href={ `#${ id }` }>{ t.title } { inDevelop }</a>
				</li>
			)
			return (
				<div key={ `${ id }-panel` } id={ id } className='col s12 no-padding theme-panel'>
					<ThemePanel theme={ t } id={ id }/>
				</div>
			)
		})
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					<ul className='tabs tabs-fixed-width'>
						{ tabs }
					</ul>
				</div>
				{ themes }
			</div>
		)
	}
}

FamilyComponent.propTypes = {
	theme: PropTypes.object,
	user: PropTypes.objectOf(DtoUser),
	sources: PropTypes.objectOf(DtoSource),
	dataTypeStatistics: PropTypes.object,
	homeFunction: PropTypes.func
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user,
		sources: store.AdministrationReducer.sources,
		dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
	}
}

export default connect(mapStateToProps)(FamilyComponent)



// WEBPACK FOOTER //
// ./src/administration/components/themeinformation/FamilyComponent.js